const doc = [({"se":({"js":({"routes":({"user":({"unicorn":({"you_are_so_cool_unicorn_go_go":"Ni är SÅ coola UNICORN á gogo"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;